import { render, staticRenderFns } from "./paragraph.vue?vue&type=template&id=0c3f33c6&scoped=true&"
import script from "./paragraph.vue?vue&type=script&lang=js&"
export * from "./paragraph.vue?vue&type=script&lang=js&"
import style0 from "./paragraph.vue?vue&type=style&index=0&id=0c3f33c6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f33c6",
  null
  
)

export default component.exports